export default {
  tip: 'có truy cập đến trang thanh toán hay không？',
  label: {
    amount: 'số tiền',
    code: 'mã kênh',
    merchantNo: 'tài khoản merchant',
    notifyUrl: 'địa chỉ callback',
    outTradeNo: 'mã giao dịch',
    sign: 'chữ ký',
    timestamp: 'chọn thời gian',
    type: 'loại thanh toán',
    params: 'params',
    getmerchantNo: 'tạo mã giao dịch',
    payLine: 'liên kết thanh toán',
    checkout: 'quầy thanh toán',
    username:'tên tài khoản',
  },
  rules: {
    amount: {
      required: 'số tiền không được để trống',
      type: 'số tiền phải là định dạng số'
    },
    merchantKey: {
      required: 'Khóa người bán không được để trống'
    },
    code: {
      required: 'mã kênh không được bỏ trống'
    },
    merchantNo: {
      required: 'tài khoản merchant không được để trống'
    },
    notifyUrl: {
      required: 'địa chỉ callback không được để trống',
      format: 'địa chỉ callback bắt buộc là http'
    },
    outTradeNo: {
      required: 'mã giao dịch không được để trống'
    },
    selfMerchantNo: {
      required: ' bắt buộc tạo lệnh giao dịch'
    },
    sign: {
      required: 'chữ ký không được để trống'
    },
    timestamp: {
      required: 'chọn thời gian'
    },
    type: {
      required: 'loại thanh toán bắt buộc chọn'
    },
    bankCode: {
      required: 'Mã ngân hàng không được để trống'
    },
    bankCardNumber: {
      required: 'Số thẻ ngân hàng không được để trống'
    },

  },
  copy: 'sao chép thành công'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/channelTest.js